module.exports = __webpack_public_path__ + "static/img/2.9286b12.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting809/images/2.png
// module id = VKfT
// module chunks = 4